/*
 * 仅用于把原 collector（collector.lizhiweike.com / data_collector）业务上报迁到玄武。
 * 新的埋点请直接调用玄武 TorDataService / emitAction，不要再使用本文件。
 */
export interface OperationLogItem {
  ubt: string
  evt: string
  evt_params?: { [key: string]: any }
}

interface QueuedOperationEvent {
  evt: string
  params: { data: OperationLogItem[] }
}

const TORTOISE_EVT: { [key: string]: string } = {
  view: 'hp_op_v',
  click: 'hp_op_ck',
  impress: 'hp_op_s'
}

let eventQueue: QueuedOperationEvent[] = []

/**
 * 玄武 init 完成后刷出缓存。先摘出当前队列，避免发送过程中新入队的事件被清掉。
 */
function flushEventQueue() {
  setTimeout(() => {
    const queue = eventQueue
    eventQueue = []
    queue.forEach(item => {
      emitOperationEvent(item.evt, item.params)
    })
  }, 0)
}

window.addEventListener('TorDataServiceInit', flushEventQueue)

/**
 * 发送一次运营埋点。对应旧 collector 的一次 POST。
 * 玄武脚本尚未挂载时整批入队，等 TorDataServiceInit 后再发。
 * @param evt 玄武事件名
 * @param params 与 collector 请求体一致：data 为日志数组，一条也放在数组里
 */
function emitOperationEvent(evt: string, params: { data: OperationLogItem[] }) {
  const torDataService = (window as any).TorDataService
  if (!torDataService) {
    eventQueue.push({ evt, params })
    return
  }
  try {
    torDataService.emitAction(evt, params)
  } catch (err) {
    console.log('emitOperationEvent', err)
  }
}

/**
 * 把原 collector 的一批 ubt 日志打到玄武。
 * 一次调用对应一次 collector POST：访问、点击各发一次；同一秒的曝光合并为一次。
 * 参数固定为 { data: [{ ubt, evt, evt_params }] }。
 * @deprecated 仅承接原 collector 上报。新埋点请直接调用玄武 TorDataService.emitAction
 */
export function reportOperationLogs(items: OperationLogItem[]) {
  if (!items.length) {
    return
  }
  const groups: { [key: string]: OperationLogItem[] } = {}
  items.forEach(item => {
    const evt = item.evt || 'view'
    if (!groups[evt]) {
      groups[evt] = []
    }
    groups[evt].push({
      ubt: item.ubt,
      evt,
      evt_params: item.evt_params || {}
    })
  })
  Object.keys(groups).forEach(evt => {
    const eventName = TORTOISE_EVT[evt] || 'hp_op_ev'
    emitOperationEvent(eventName, { data: groups[evt] })
  })
}



// WEBPACK FOOTER //
// ./src/services/tortoiseReport.ts